export default __webpack_public_path__ + "static/media/product_1.5280564c.png";